import axios from 'axios'
import appconst from './appconst'
import Vue from 'vue'
const ajax = axios.create({
    baseURL: appconst.remoteServiceBaseUrl,
    timeout: 30000
});
ajax.interceptors.request.use(function (config) {
    if (!!window.abp.auth.getToken()) {
        config.headers.common["Authorization"] = "Bearer " + window.abp.auth.getToken();
    }
    config.headers.common[".AspNetCore.Culture"] = window.abp.utils.getCookieValue("Abp.Localization.CultureName");
    config.headers.common["Abp.TenantId"] = window.abp.multiTenancy.getTenantIdCookie();
    return config;
}, function (error) {

    return Promise.reject(error);
});
let vm = new Vue({});
ajax.interceptors.response.use((respon) => {
    return respon
}, (error) => {
    console.log(error.response)
    if (!!error.response && !!error.response.data.error && !!error.response.data.error.message && error.response.data.error.details) {
        vm.$Modal.error({ title: error.response.data.error.message, content: error.response.data.error.details })
    } else if (!!error.response && !!error.response.data.error && !!error.response.data.error.message) {
        if (error.response.status == 401) {
            vm.$Modal.error({
                title: window.abp.localization.localize("验证失败"),
                content: error.response.data.error.message,
                onOk: () => {
                    sessionStorage.removeItem('userId');
                    sessionStorage.removeItem('remeberMe');
                    sessionStorage.removeItem('isGeneral');
                    location.reload();
                }
            })

        } else {
            vm.$Modal.error({ title: window.abp.localization.localize("验证失败"), content: error.response.data.error.message })

        }

    } else if (!error.response) {
        vm.$Modal.error(window.abp.localization.localize('未知错误'));
    }
    setTimeout(() => {
        vm.$Message.destroy();

    }, 3000);
    return Promise.reject(error);
})
export default ajax;